import Kline from './js/kline'

window.Kline = Kline;

export default Kline